export default __webpack_public_path__ + "static/media/sjbarracuda-logo.2217a246.svg";